module.exports = __webpack_public_path__ + "img/FR16998.7db95c4f.png";